export const FUEL_FLEX_ID = 6;
